// extracted by mini-css-extract-plugin
module.exports = {"link":"policies_link__cycL6"};